/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Terms_Emptydescription1Inputs */

const en_welcome_terms_emptydescription1 = /** @type {(inputs: Welcome_Terms_Emptydescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are no terms and conditions available to review right now. Please log out and try again later, or contact support if the problem persists.`)
};

/**
* | output |
* | --- |
* | "There are no terms and conditions available to review right now. Please log out and try again later, or contact support if the problem persists." |
*
* @param {Welcome_Terms_Emptydescription1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const welcome_terms_emptydescription1 = /** @type {((inputs?: Welcome_Terms_Emptydescription1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Terms_Emptydescription1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_terms_emptydescription1(inputs)
});
export { welcome_terms_emptydescription1 as "welcome_terms_emptyDescription" }